import * as types from './types';

const project = {
  id: '',
};

export const state = {
  project,
  images: {},
  title: '',
  description: '',
};

export const mutations = {
  [types.SET_PROJECT](state, project) {
    state.project = project;
  },
  [types.SET_TITLE](state, title) {
    state.title = title;
  },
  [types.SET_DESCRIPTION](state, description) {
    state.description = description;
  },
  [types.RESET_PROJECT_DATA](state) {
    state.project = project;
  },
  [types.SET_IMAGES](state, images) {
    state.images = Object.assign({}, images);
  },
};



// WEBPACK FOOTER //
// ./src/screens/App/store/mutations.js